import { useSignupCountries } from '../hooks';
import CountrySelectBase, { CountrySelectBaseProps } from './CountrySelectBase';

export interface CountrySelectPresetProps extends Omit<CountrySelectBaseProps, 'countries'> { };

const CountrySelectPreset = (props: CountrySelectPresetProps) => {
  const { countries, error, loading } = useSignupCountries();

  return <CountrySelectBase
    {...props}
    countries={countries}
    errorMessage={error ? props.errorMessage : undefined}
    loadingMessage={loading ? props.loadingMessage : undefined}
  />
};



export default CountrySelectPreset;
